// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__gO_Lr","productName":"Table_productName__3ek8e"};